const FILTER_DRAWER_WIDTH = 220;

export function calculateMainContentWidth({
    width,
    isFilterDrawerOpen,
}: {
    width: number;
    isFilterDrawerOpen: boolean;
}) {
    return isFilterDrawerOpen ? width - FILTER_DRAWER_WIDTH : width;
}
